
const SCREEN_WIDTH_SMALL: number = 980;
const CLASS_OPENED: string = 'opened';
const CLASS_RESET_CLICK: string = 'reset-click';
let isOpen: boolean = false;

function main(): void
{
	const container = document.querySelector( 'header>div.container>ul.languages' ) as HTMLElement;
	
	if ( !container )
	{
		return;
	}
	
	/** нажатие на кнопку мыши */
	const documentClickHandler = ( event: Event ) =>
	{
		close( event, container );
		document.body.classList.remove( CLASS_RESET_CLICK );
		document.removeEventListener( 'click', documentClickHandler, true );
	};
	
	container.addEventListener( 'click', ( event: Event ) => open( event, container, documentClickHandler ) );
}

function open( event: Event, container: HTMLElement, documentClickHandler: ( event: Event ) => void ): void
{
	if ( isModeMobile() )
	{
		if ( !isOpen )
		{
			container.classList.add( CLASS_OPENED );
			isOpen = true;
			document.body.classList.add( CLASS_RESET_CLICK );
			document.addEventListener( 'click', documentClickHandler, true );
		}
		else
		{
			if ( event.target !== container )
			{
				close( event, container );
			}
		}
	}
	else
	{
		close( event, container );
	}
}

function close( event: Event, container: HTMLElement ): void
{
	container.classList.remove( CLASS_OPENED );
	isOpen = false;
}

function isModeMobile()
{
	return ( window.innerWidth < SCREEN_WIDTH_SMALL );
}

export {
	main as default,
}
